import enums from '../enums.js';

const componentNames = ['control', 'controlKnob', 'controlVoid'];
const config = {
  expressions: [
    enums.expressions.CRITICAL
  ],
  interactions: [
    enums.interactions.FOCUSED,
    enums.interactions.HOVERED,
    enums.interactions.CHOSEN
  ],
  styleProperties: [
    enums.properties.BACKGROUND_COLOR,
    enums.properties.FOREGROUND_COLOR,
    enums.properties.BORDER_COLOR,
    enums.properties.OUTLINE_COLOR,
    enums.properties.BORDER_RADIUS,
    enums.properties.BORDER_WIDTH
  ]
};

export default componentNames.reduce((obj, name) => Object.assign(obj, { [name]: config }), {});
